import { render, staticRenderFns } from "./Watch.vue?vue&type=template&id=9dcfaf8e&"
import script from "./Watch.js?vue&type=script&lang=js&"
export * from "./Watch.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports